module.exports = __webpack_public_path__ + "static/media/features3.fe7ea8af.jpg";